import { apiRequest } from './api';
import { decodeSubmissionStatus } from './contestDecoders';
import {
  decodeDailyData,
  decodeProblemDetail,
  decodeProblemSubmissions,
  decodeProblemsList,
  decodeProfileStats,
  decodeQuestionCounts,
  decodeTags,
  decodeTopicsList,
  decodeUserSubmissions,
} from './decoders';

export const practiceApi = {
  problems: () => apiRequest('/platform/questions', {}, decodeProblemsList),
  topics: () => apiRequest('/platform/topics', {}, decodeTopicsList),
  daily: (year, month) => apiRequest(`/platform/daily-question?year=${year}&month=${month}`, {}, decodeDailyData),
  problem: (problemId) => apiRequest(`/platform/question/${problemId}`, {}, decodeProblemDetail),
  tags: (problemId) => apiRequest(`/platform/question/${problemId}/tags`, {}, decodeTags),
  run: (problemId, body) => apiRequest(`/platform/run/${problemId}`, { method: 'POST', body }),
  runStatus: (token) => apiRequest(`/platform/run/${token}`),
  submit: (problemId, body) => apiRequest(`/platform/submit/${problemId}`, { method: 'POST', body }),
  submissionStatus: (submissionId) => apiRequest(`/platform/submission/${submissionId}`, {}, decodeSubmissionStatus),
  submissions: (problemId) => apiRequest(`/platform/question/${problemId}/submissions`, {}, decodeProblemSubmissions),
  profileStats: (userId) => apiRequest(`/platform/user/${userId}`, {}, decodeProfileStats),
  questionCounts: () => apiRequest('/platform/questions/count', {}, decodeQuestionCounts),
  userSubmissions: (userId) => apiRequest(`/platform/submissions/user/${userId}`, {}, decodeUserSubmissions),
};
